import styled from 'styled-components';
import { spacing, hideVisually, containers } from '@comicrelief/component-library';

const Wrapper = styled.div`
  background: ${props => ({ theme }) => theme.color(props.bgColor)};
  text-align: center;
  padding: ${({ paddingTop, paddingBottom }) => `${paddingTop} 1rem ${paddingBottom}`};
`;

const Grid = styled.div`
  display: flex;
  max-width: ${containers.medium};
  justify-content: center;
  margin: ${spacing('l')} auto ${spacing('md')};
  flex-direction: column;

  @media ${({ theme }) => theme.allBreakpoints('L')} {
    flex-direction: row;
    margin-bottom: ${spacing('l')};
  }
`;

const Items = styled.div`
  margin: ${spacing('md')} 0;
  width: 100%;
  text-align: left;

  @media ${({ theme }) => theme.allBreakpoints('L')} {
    margin: ${spacing('md')};
    width: calc(100% / 3 - ${spacing('md')});
  }
`;

const HideText = styled.span`
  ${({ hideText }) => hideText && hideVisually};
`;

export {
  Wrapper, Grid, Items, HideText
};
